<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="费用明细"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="625px"
  >
    <div class="dialog__container lift-price__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        label-width="70px"
      >
        <el-row v-for="(item, index) in form.liftUnitPriceList" :key="index" style="margin-bottom:12px;">
          <el-col :span="4">
            <div class="lift-price-title">电梯单价</div>
          </el-col>
          <el-col :span="5">
            <el-input
              class="lift-price-input"
              size="mini"
              type="number"
              clearable
              :disabled="!canEdit"
              v-model.number="form.liftUnitPriceList[index].price"
            >
              <span slot="suffix">元</span>
            </el-input>
          </el-col>
          <el-col :span="5" :offset="1">
            <el-input
              class="lift-price-input"
              size="mini"
              type="number"
              clearable
              :disabled="!canEdit"
              v-model.number="form.liftUnitPriceList[index].liftNum"
            >
              <span slot="suffix">台</span>
            </el-input>
          </el-col>
          <el-col :span="5" :offset="1">
            <el-input
              class="lift-price-input"
              size="mini"
              type="number"
              clearable
              :disabled="!canEdit"
              v-model.number="form.liftUnitPriceList[index].year"
            >
              <span slot="suffix">年数</span>
            </el-input>
          </el-col>
          <el-col :span="3">
            <span
              @click="handleDeleteLiftPrice(index)"
              class="lift-price-add-span lift-price-delete-span"
              v-if="index !== 0"
              >删除</span
            >
          </el-col>
        </el-row>
        <hr />
        <div style="margin-bottom:12px;"></div>
        <el-row
          v-for="(item, index) in form.otherCostDTOList"
          :key="index + form.liftUnitPriceList.length"
          style="margin-bottom:12px;"
        >
          <el-col :span="4">
            <div class="lift-price-title">其他费用</div>
          </el-col>
          <el-col :span="5">
            <el-input
              class="lift-price-input"
              size="mini"
              type="number"
              clearable
              :disabled="!canEdit"
              v-model.number="form.otherCostDTOList[index].price"
            >
              <span slot="suffix">元</span>
            </el-input>
          </el-col>
          <el-col :span="5" :offset="1">
            <el-input
              class="lift-price-input"
              size="mini"
              type="number"
              clearable
              :disabled="!canEdit"
              v-model.number="form.otherCostDTOList[index].amount"
            >
              <span slot="suffix">个</span>
            </el-input>
          </el-col>
          <el-col :span="5" :offset="1"> </el-col>
          <el-col :span="3" v-if="canEdit">
            <span
              @click="handleAddOtherCost"
              class="lift-price-add-span"
              v-if="index == 0"
              >添加</span
            >
            <span
              @click="handleDeleteLiftOtherPrice(index)"
              class="lift-price-add-span lift-price-delete-span"
              v-if="index !== 0"
              >删除</span
            >
          </el-col>
        </el-row>
        <hr />
        <div style="margin-bottom:12px;"></div>
        <el-row style="margin-bottom:12px;">
          <el-col :span="4">
            <div class="lift-price-title">明细合计</div>
          </el-col>
          <el-col :span="5">
            <el-input
              class="lift-price-input"
              size="mini"
              :value="feeDetailTotal"
              disabled
            >
              <span slot="suffix">元</span>
            </el-input>
          </el-col>
        </el-row>
        <div class="lift-price-error">{{ liftPriceError }}</div>
        <span v-if="canEdit" class="lift-price-add-span" @click="handleAddLiftPrice"
          >添加</span>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="plr28"
        size="mini"
        type="info"
        plain
        @click="handleCancel"
        >取消</el-button
      >
      <el-button class="plr28" type="primary" size="mini" @click="handleConfirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import NP from 'number-precision'
export default {
  data() {
    return {
      form: {
        liftUnitPriceList: [
          {
            liftNum: null,
            price: null,
            year: 1,
          },
        ],
        otherCostDTOList: [
          {
            price: null,
            amount: null
          }
        ],
      },
      liftPriceError: '',
    };
  },

  components: {},
  created() {},
  mounted() {
    if (this.liftUnitPriceList && this.liftUnitPriceList.length) {
      this.form.liftUnitPriceList = [...this.liftUnitPriceList]
    }
    if (this.otherCostDTOList && this.otherCostDTOList.length) {
      this.form.otherCostDTOList = [...this.otherCostDTOList]
    }

  },
  props: {
    contractAmount: {
      required: true
    },
    otherCostDTOList: {
      required: false
    },
    liftUnitPriceList: {
      required: false
    },
    canEdit: {
      required: true
    }
  },
  computed: {
    feeDetailTotal() {
      let total = 0
      if (
        this.form.liftUnitPriceList &&
        this.form.liftUnitPriceList.length > 0
      ) {
        this.form.liftUnitPriceList.forEach((item) => {
          if (item.price && item.liftNum && item.year) {
            const price = parseFloat(item.price)
            const liftNum = parseFloat(item.liftNum)
            const year = parseFloat(item.year)
            if (price && liftNum && year) {
              const temp = NP.times(price, liftNum, year)
              total += temp
            }
          }
        })
      }
      if (this.form.otherCostDTOList && this.form.otherCostDTOList.length > 0) {
        this.form.otherCostDTOList.forEach((item) => {
          if (item.price && item.amount) {
            const price = parseFloat(item.price)
            const amount = parseFloat(item.amount)
            if (price && amount) {
              const temp = NP.times(price, amount)
              total += temp
            }
          }
        })
      }
      return total
    }
  },
  methods: {
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      console.log(this.form.liftUnitPriceList)
      console.log(this.form.otherCostDTOList)
      if (NP.minus(this.feeDetailTotal, this.contractAmount) != 0) {
        this.liftPriceError = "费用明细与合同总额不一致"
      } else {
        this.liftPriceError = ''
        this.$emit("confirm", this.form)
      }
      
    },
    handleAddOtherCost() {
      this.form.otherCostDTOList.push({
        price: null,
        amount: null
      })
    },
    handleAddLiftPrice() {
      this.form.liftUnitPriceList.push({
        price: null,
        liftNum: null,
        year: 1
      })
    },
    handleDeleteLiftPrice(index) {
      this.form.liftUnitPriceList.splice(index, 1);
    },
    handleDeleteLiftOtherPrice(index) {
      this.form.otherCostDTOList.splice(index, 1)
    },
  },
};
</script>

<style lang="scss">
.lift-price__container {
  position: relative;
  & > div {
    margin-bottom: 10px;
    
  }
  .lift-price-error {
      margin: 0;
      color: #f56c6c;
    }
  .el-input__suffix {
    display: flex;
    align-items: center;
  }
}
.lift-price-add-span {
  position: absolute;
  line-height: 1;
  color: #409eff;
  right: 0;
  top: 7px;
  cursor: pointer;
}
.lift-price-delete-span {
  color: #f56c6c;
}
.lift-price-title {
  line-height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/pages/ContractManagement/components/SettingPrice.vue